<i class="ti-close" (click)="openModal(category_delete)"></i>
<ng-template #category_delete>
    <div class="category_delete">
        <div class="modal-body d-flex justify-content-between flex-column">
            <div class="m-auto">
                <div>
                    Are you sure you want to delete the category?
                </div>
                <div>
                    Questions in this category will also be
                    removed.
                </div>
            </div>
            <div class="btn-modal">
                <span (click)="delete()" [class.disabled]="inOnDeleting">Yes</span>
                <span (click)="modalRef.hide()">Cancel</span>
            </div>
        </div>
    </div>
</ng-template>
